export function isFieldEnabled(field, valuesByFieldId) {
  if (!field.dependsOnFieldId) return true;
  const parentValue = valuesByFieldId[field.dependsOnFieldId];
  return String(parentValue) === String(field.dependsOnValue);
}

export function isValueEmpty(field) {
  if (field.fieldType === 'COMBO') return !field.value || field.value.length === 0;
  return field.value === null || field.value === undefined || field.value === '';
}

export function isDependentFieldUnfilled(field, valuesByFieldId) {
  if (!field.dependsOnFieldId) return false;
  if (!isFieldEnabled(field, valuesByFieldId)) return false;
  return isValueEmpty(field);
}

export function onParentChange(fields) {
  const getDependentDefaultValue = (field) => {
    if (field.fieldType === 'CHECKBOX') return 'false';
    if (field.fieldType === 'COMBO') return [];
    return null;
  };

  const buildValuesMap = () => {
    const map = {};
    fields.forEach(f => { map[f.idAppConfigField] = f.value; });
    return map;
  };

  let changed;
  do {
    changed = false;
    const valuesMap = buildValuesMap();
    fields.forEach(f => {
      if (!isFieldEnabled(f, valuesMap)) {
        const defaultValue = getDependentDefaultValue(f);
        if (f.value !== defaultValue) {
          f.value = defaultValue;
          changed = true;
        }
      }
    });
  } while (changed);
}
